/**
 * Safari/iOS 26.5+ (WebKit 319985, 319396, 320904): con service worker activo, los archivos
 * que vienen del disco (selector, Archivos, Fotos) se envían con el cuerpo multipart vacío.
 * Leerlos desde la página sí funciona, así que se sube una copia en memoria con el mismo
 * nombre, tipo y fecha. Si no se puede leer (iCloud sin descargar…), se devuelve el original.
 */
export async function memoryCopy(file: File): Promise<File> {
    try {
        const buffer = await file.arrayBuffer();
        return new File([buffer], file.name, {type: file.type, lastModified: file.lastModified});
    } catch {
        return file;
    }
}
